import { A2kPanel } from "./A2kPanel.js";
window.customElements.define("a2k-panel", A2kPanel);
